import ajaxService from './ajaxService';

class LoadMore {
    constructor(element) {
        this.container = element;

        this.loading = false;

        this.maxCount = 20;
        const {maxCount} = this.container.dataset;
        if (maxCount) {
            this.maxCount = maxCount;
        }

        this.button = this.container.querySelector('.js-wpfl-social-wall-load-more-button');
        this.content = this.container.querySelector('.js-wpfl-social-wall-content');
        this.loadingContent = this.container.querySelectorAll('.js-wpfl-social-wall-loading-content');

        const lastItems = this.container.querySelectorAll('.js-wpfl-social-wall-load-more-last');
        const lastItemElement = lastItems.length ? lastItems[lastItems.length - 1] : null;

        const templateElement = this.container.querySelector('.js-wpfl-social-wall-template');

        if (lastItemElement && templateElement) {
            const {itemId} = lastItemElement.dataset;
            this.beforeId = itemId;

            const {template} = templateElement.dataset;
            this.template = template;

            if (this.button && this.content && this.loadingContent && this.beforeId && this.template) {
                this.initLoadMoreEvent();
            }
        }
    }

    static formatDate(date) {
        if (!date) {
            return '';
        }

        const dateString = Date(date);
        const dateObject = new Date(dateString);

        const day = dateObject.getDate();
        const month = dateObject.getMonth();
        return `${day < 10 ? '0' : ''}${day}.${month < 10 ? '0' : ''}${month}.${dateObject.getFullYear()}`;
    }

    insertNewItem(item) {
        let {template} = this;

        let {textLength} = this.container.dataset;
        const typeTextLengthKey = `textLength${item.type.charAt(0).toUpperCase()}${item.type.slice(1)}`;
        if (Object.hasOwnProperty.call(Object.keys(this.container.dataset), typeTextLengthKey)) {
            textLength = this.container.dataset[typeTextLengthKey];
        }

        const content = item.comment.length > textLength ? `${item.comment.slice(0, textLength)}…` : item.comment;

        template = template.replaceAll('identifier', item.id);
        template = template.replaceAll('post_link', item.post_link);
        template = template.replaceAll('post_content', content);
        template = template.replaceAll('post_image', item.post_image);
        template = template.replaceAll('post_webp_image', item.post_webp_image);
        template = template.replaceAll('post_timetext', item.created_text);
        template = template.replaceAll('post_created', LoadMore.formatDate(item.created));
        template = template.replaceAll('post_type', item.type);
        template = template.replaceAll('external_name', item.external_name);

        if (item.post_image) {
            template = template.replace('social-wall__block ', 'social-wall__block has-image ');
        }

        const beforeElement = document.querySelector(`[data-item-id="${this.beforeId}"]`);
        if (beforeElement) {
            beforeElement.insertAdjacentHTML('afterEnd', template);
        }
    }

    initLoadMoreEvent() {
        this.button.addEventListener('click', (event) => {
            if (!this.loading) {
                event.preventDefault();

                this.startLoadingAnimation();

                // eslint-disable-next-line max-len
                const url = `${window.location.protocol}//${window.location.hostname}/wp-json/wpfl-social-wall/v1/articles/?wpfl_max_id=${this.beforeId}&wpfl_count=${this.maxCount}`;

                ajaxService.get(url).then((response) => {
                    this.jsonData = response;

                    for (let i = 0; i < this.jsonData.length; i += 1) {
                        const data = this.jsonData[i];

                        this.insertNewItem(data);

                        this.beforeId = data.id;
                    }

                    this.stopLoadingAnimation();

                    if (this.jsonData.length < this.maxCount) {
                        this.button.parentNode.removeChild(this.button);
                    }
                }, () => {
                    this.stopLoadingAnimation();
                });
            }
        });
    }

    startLoadingAnimation() {
        this.loading = true;
        this.button.disabled = true;
        this.loadingContent.forEach((element) => {
            element.classList.add('social-wall-loading-animation', 'wpfl');
        });
    }

    stopLoadingAnimation() {
        this.loading = false;
        this.button.disabled = false;
        this.loadingContent.forEach((element) => {
            element.classList.remove('social-wall-loading-animation', 'wpfl');
        });
    }
}

const loadMore = {
    init() {
        const elements = document.querySelectorAll('.js-wpfl-social-wall');
        if (!elements.length) return;

        for (let i = 0; i < elements.length; i += 1) {
            // eslint-disable-next-line no-new
            new LoadMore(elements[i]);
        }
    },
};

export default loadMore;
